import React, {memo} from 'react';
import Card from "./layout/Card";

function Skills(
    props: {
        skills: Array<{ img: string, alt: string, name: string, description?: string }>
    }
) {
    return (
        <section id={`Skills`} className={'bg-gray-50 pt-12 pb-32'}>
            <h3 className={`text-3xl text-center`}>My Skills</h3>
            <p className={`text-lg mb-20 text-gray-500 text-center`}>What technologies i can work by?</p>

            <div className={`grid grid-cols-auto m-5 md:mx-40 gap-10 place-items-center`}>
                {props.skills.map(skill => <Card
                    key={skill.name}
                    title={skill.name}
                    description={skill.description}
                    imgAlt={skill.alt}
                    imgSrc={skill.img}
                />)}
            </div>
        </section>
    )
}

export default memo(Skills)